import { appConfig } from "../../config/appConfig";
import { headerConfig } from "../../config/headerConfig";
import auth from "../auth";

export const categoryService = {
  addCategory
};

function addCategory(data) {
  let token = auth.getToken();
  let header_data = "";
  if (token != "") {
    var Authheader = "Authorization";
    var AuthheaderVal = "Bearer " + token;
    headerConfig.headerDatas[Authheader] = AuthheaderVal;
    header_data = headerConfig.headerDatas;
  } else {
    header_data = headerConfig.headerDatas;
  }

  const requestOptions = {
    method: "POST",
    headers: header_data,
    body: JSON.stringify({ data })
  };

  return fetch(`${appConfig.api.url}deals/category/add`, requestOptions)
    .then(handleResponse)
    .then(category => {
      return category;
    });
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        logout();
        location.reload(true);
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}



// WEBPACK FOOTER //
// ./src/app/services/API/categoryService.js